module.exports = __webpack_public_path__ + "static/media/success.11c286ca.gif";